import axios from "axios";
import { lodgingCancelApi as defaultLodgingCancelApi } from "@b2bportal/lodging-cancel-api";

export const hotelsCancelApi = defaultLodgingCancelApi(axios);
